export const INDIVIDUAL_INSTRUCTIONS = [
  "Details (e.g. name, address, tax ID, etc.)",
  "Identification documents (e.g. drivers license, passport, etc.)",
];

export const ENTITY_INSTRUCTIONS = [
  "Details (e.g. name, address, tax ID, etc.)",
  "Documents",
  "Organization structure of your owners and controllers",
  "Details for owners and controllers (e.g. name, address, tax ID, etc.)",
  "Documents for owners and controllers",
];

export const JOINT_INSTRUCTIONS = [
  "Details (e.g. name & domicile.)",
  "List of owners",
  "Details for the owners (e.g. name, address, tax ID, etc.)",
  "Documents for owners",
];
